<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.studies.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!studiesItems.length" class="panel--empty">
                    <center>{{$t('dashboard.studies.no_studies')}}</center>
                </div>
                <div v-else class="panel__list">
                    <div v-for="(item, index) in studiesItems" :key="`study_${item.id}_${index}`" class="panel__list__item">
                        <span>{{item.start_date | formatDate}} - {{item.end_date ? ($options.filters.formatDate(item.end_date)) : $t('dashboard.studies.ongoing')}}</span>
                        <h3 class="purple">{{item.study_name || item.study_name_other}}</h3>
                        <h3>{{item.institute_name}}</h3>
                        <span>{{$t('dashboard.studies.diploma_achieved')}} : {{item.finished ? $t('common.yes') : $t('common.no')}}</span>
                    </div>
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.studies.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.studies.see_all')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component({})
    export default class StudiesPanel extends Vue {
        name = 'study-panel';
        expanded = false;

        get studiesItems() {
            return this.$store.state.profile.profile.studies || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.studiesItems.length && this.studiesItems.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/StudiesPanel.vue